import { type Story } from 'types/api/story'

export const integrateStoryAnswer = ({
  story,
  answer,
  answerId
}: {
  story: Story
  answer?: string | null
  answerId?: string
}) => {
  const newStory = story

  if (!newStory.poll) {
    return story
  }

  const previousAnswer = newStory.poll.is_answered

  if (previousAnswer) {
    const prevAnswerIndex = newStory.poll.answers_count.findIndex(
      pollAnswer => {
        if (typeof previousAnswer === 'string') {
          return (
            pollAnswer.text === previousAnswer ||
            pollAnswer.id === previousAnswer
          )
        }

        return false
      }
    )

    if (prevAnswerIndex !== -1) {
      newStory.poll.answers_count[prevAnswerIndex].count -= 1
    }
  }

  if (answerId) {
    const answerIndex = newStory.poll.answers_count.findIndex(
      pollAnswer => pollAnswer.id === answerId
    )

    if (answerIndex !== -1) {
      newStory.poll.answers_count[answerIndex].count += 1
    }

    newStory.poll.is_answered = answerId
  } else if (answer) {
    newStory.poll.is_answered = answer
  }

  return newStory
}